var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"d-flex justify-center align-center"},[_c('div',{staticClass:"display-1"},[_vm._v("coming soon!")])])}
var staticRenderFns = []

export { render, staticRenderFns }